<template>
  <ConfirmModal
    ref="modalRef"
    title="Discard unsaved changes?"
    :description="`You edited ${tabName} but didn't save. Leaving this tab discards the changes.`"
    confirm-label="Discard"
    cancel-label="Keep editing"
    @confirm="discard"
    @after-close="resolveWith(false)"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { ConfirmModal } from '@tallo/design-system';

const modalRef = ref<InstanceType<typeof ConfirmModal>>();
const tabName = ref('');

let resolver: ((discard: boolean) => void) | null = null;

/** Resolves true when the user chooses to discard, false on keep-editing/close/esc */
function confirm(currentTabName: string): Promise<boolean> {
  tabName.value = currentTabName;
  modalRef.value?.show();

  return new Promise((resolve) => {
    resolver = resolve;
  });
}

function discard() {
  resolveWith(true);
  modalRef.value?.close();
}

function resolveWith(discard: boolean) {
  resolver?.(discard);
  resolver = null;
}

defineExpose({ confirm });
</script>
